import { type ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className = '' }: CardProps) {
  return (
    <div
      className={`overflow-hidden rounded-2xl border border-slate-200/60 bg-white shadow-soft ${className}`}
    >
      {children}
    </div>
  );
}
